import React from 'react'

import CreateTimeForm from './CreateTimeForm'

interface CreateTimeProps {
  aircraft: {
    id: string
    tailNumber: string
    model: string
    components: Array<{
      id: string
      name: string
      partNumber?: string
      serialNumber?: string
    }>
  }
  onSuccess?: (usageLogId: string) => void
}

const CreateTime: React.FC<CreateTimeProps> = ({ aircraft, onSuccess }) => {
  return <CreateTimeForm aircraft={aircraft} onSuccess={onSuccess} />
}

export default CreateTime
